import React, { FC } from 'react';

import { Alert, ErrorBoundary, useStyles2 } from '@grafana/ui';

import { css } from '@emotion/css';

import { CheckSteps } from 'projects/Sift/Components/CheckSteps';
import { Analysis, Investigation } from 'types';
import { getAnalysisDisplayTitle } from 'utils/utils.sift';

import CustomDetailsPanel from '../AnalysisDetails';
import { Card } from './Card';

// Component Props Interface
interface Props {
  investigation: Investigation;
  analyses: Analysis[];
  selectedAnalysisId?: string;
  onSelection: (analysisId: string) => void;
}

// Declare Component
export const CardContainer: FC<Props> = ({ investigation, analyses, selectedAnalysisId, onSelection }) => {
  const styles = useStyles2(getStyles);
  const selectedAnalysis = analyses.find((analysis) => analysis.id === selectedAnalysisId);

  if (selectedAnalysis !== undefined) {
    return (
      <div>
        <ErrorBoundary key={selectedAnalysis.id} dependencies={[investigation.id, selectedAnalysis.id]}>
          {({ error }) => {
            if (error) {
              return (
                <Alert title="Error showing check results">
                  <p>There was an error showing the results of this check.</p>
                  <pre>
                    {error.message}
                    {error.stack && `\n\n${error.stack}`}
                  </pre>
                </Alert>
              );
            }
            return (
              <>
                <h2>{getAnalysisDisplayTitle(selectedAnalysis.name, selectedAnalysis.title)}</h2>
                <CustomDetailsPanel investigation={investigation} analysis={selectedAnalysis} />
                <CheckSteps analysis={selectedAnalysis} />
              </>
            );
          }}
        </ErrorBoundary>
      </div>
    );
  }

  return (
    <div className={styles.listContainer}>
      {analyses.map((analysis) => (
        <Card key={analysis.id} analysis={analysis} onSelection={onSelection} />
      ))}
    </div>
  );
};

const getStyles = () => {
  return {
    listContainer: css`
      display: flex;
      flex-direction: rows;
      flex-wrap: wrap;
      gap: 16px;
    `,
  };
};

// Export Component
export default CardContainer;
